import type { SplitterDesignTokens } from '@primeuix/themes/types/splitter'

export default {
  root: {
    color: '{content.color}',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    transitionDuration: '{transition.duration}',
  },
  gutter: {
    background: '{content.border.color}',
  },
  handle: {
    size: '24px',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    borderRadius: '{content.border.radius}',
  },
  colorScheme: {
    dark: {
      handle: {
        background: '{surface.600}',
      },
    },
    light: {
      handle: {
        background: '{surface.400}',
      },
    },
  },
} satisfies SplitterDesignTokens
